import { Component } from '@angular/core';

declare const MW: any;
declare const BABYLON: any;
declare const setupScene: any;
declare const MAP: any;

@Component({
  selector: 'app2',
  templateUrl: './app2.component.html'
})
export class App2Component {
  items = [];
  group;
  scene;

  ngOnInit() {
    this.scene = setupScene("canvas2");
    this.group = new BABYLON.AbstractMesh("group", this.scene);
    this.add();
    this.add();
  }

  createCube(index) {
    var data = {};
    var material = new BABYLON.StandardMaterial("material" + index, this.scene);
    var cube = new BABYLON.Mesh.CreateBox("box" + index, 1, this.scene);
    cube.material = material;
    this.group.addChild(cube);
    
    new MW.TwoWayMap({
        end1: data,
        map1: MAP.CUBE.to3DModel,
        end2: cube,
        map2: MAP.CUBE.toDataModel,
        data1: {
            color: "#ff9900",
            element: cube,
            index: index,
            size: { x: 1, y: 1, z: 1 },
            position: { x: 0, y: 0, z: 0 },
        }
    });

    this.group.position.x = - index;
    cube.position.x = index * 2;
    return data;
  }

  add() {
    this.items.push(this.createCube(this.items.length));
  }

  remove(index) {
    var mesh = this.items[index].element;
    this.group.removeChild(mesh);
    this.scene.removeMesh(mesh);
    this.items.splice(index, 1);
    for (var i = index; i < this.items.length; i++) {
        var oldX = this.items[i].position.x;
        this.items[i].index = i;
        this.items[i].element.position.x = this.items[i].element.position.x - 2;
    }
    this.group.position.x = - (this.items.length - 1);
  }
}